import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentLeadContactProps {
  contactId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useDeleteEstablishmentLeadContact = ({ contactId, onSuccess, onError }: UseDeleteEstablishmentLeadContactProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['deleteEstablishmentLeadContact'],
    mutationFn: async () => {
      await privateAxios.delete(`/funnel/contacts/${contactId}`)
    },
    onSuccess,
    onError,
  })
}
